"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.compactMap = exports.mostEncounteredValue = exports.insertAt = exports.itemBefore = exports.itemAfter = exports.cloneDeepWithOptions = exports.omitDeep = exports.omitDeepNil = exports.omitUndefined = exports.omitDeepUndefined = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const lodash_1 = __importDefault(require("lodash"));
/**
 * Recursively removes all undefined properties
 */
function omitDeepUndefined(value) {
    return omitDeep(value, [undefined]);
}
exports.omitDeepUndefined = omitDeepUndefined;
function omitUndefined(value) {
    return lodash_1.default.pickBy(value, (v) => v !== undefined);
}
exports.omitUndefined = omitUndefined;
/**
 * Recursively removes all undefined properties
 */
function omitDeepNil(value) {
    return omitDeep(value, [undefined, null]);
}
exports.omitDeepNil = omitDeepNil;
function omitDeep(value, omittedValues) {
    if (lodash_1.default.isArray(value)) {
        const newArrayValues = lodash_1.default.map(value, (v) => omitDeep(v, omittedValues));
        return lodash_1.default.without(newArrayValues, ...omittedValues);
    }
    if (lodash_1.default.isObject(value)) {
        const omittedValue = lodash_1.default.mapValues(value, (v) => omitDeep(v, omittedValues));
        return lodash_1.default.omitBy(omittedValue, (v) => omittedValues.includes(v));
    }
    return value;
}
exports.omitDeep = omitDeep;
function cloneDeepWithOptions(obj, options) {
    return lodash_1.default.cloneDeepWith(obj, (value) => {
        if (options.replaceDateWithTimestamps && lodash_1.default.isDate(value)) {
            return value.getTime();
        }
        return undefined;
    });
}
exports.cloneDeepWithOptions = cloneDeepWithOptions;
function itemAfter(array, predicate) {
    const index = lodash_1.default.findIndex(array, predicate);
    return array[index + 1];
}
exports.itemAfter = itemAfter;
function itemBefore(array, predicate) {
    const index = lodash_1.default.findIndex(array, predicate);
    return array[index - 1];
}
exports.itemBefore = itemBefore;
function insertAt(array, value, index) {
    array.splice(index, 0, value);
    return array;
}
exports.insertAt = insertAt;
function mostEncounteredValue(values) {
    const grouped = lodash_1.default.groupBy(values);
    const pairs = lodash_1.default.toPairs(grouped);
    const sorted = lodash_1.default.sortBy(pairs, (pair) => pair[1].length);
    const pair = lodash_1.default.last(sorted);
    return pair && pair[0];
}
exports.mostEncounteredValue = mostEncounteredValue;
/** maps and removes all nulls and undefineds from the array */
function compactMap(collection, iteratee) {
    return lodash_1.default.compact(lodash_1.default.map(collection, iteratee));
}
exports.compactMap = compactMap;
//# sourceMappingURL=lodash-utils.js.map